import { withJsonFormsControlProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useMemo } from "react";
import { useDistinctKeywordGroupsField } from "../../../hooks/useDistinctKeywordGroupsField";

const DistinctFieldSelectComponent = ({
  handleChange,
  label,
  path,
  required,
  visible,
  enabled,
  data,
  uischema,
}) => {
  const field = uischema?.options?.field || path;
  const { options, loading, error } = useDistinctKeywordGroupsField(field);

  const selected = useMemo(() => {
    if (data == null || data === "") return [];
    const value = String(data);
    const match = options.find((option) => option.id === value);
    return match ? [match] : [{ id: value, displayText: value }];
  }, [options, data]);

  const handleSelectValue = (values) => {
    const value =
      Array.isArray(values) && values.length > 0 ? values[0].id : undefined;
    handleChange(path, value || undefined);
  };

  if (!visible) return null;

  const isEmpty = !loading && !error && options.length === 0;
  const placeholder =
    uischema?.options?.placeholder ||
    (loading
      ? `Loading ${label || field}...`
      : isEmpty
        ? `No ${label || field} available`
        : `Select ${label || field}`);

  return (
    <div className="multiple-select-wrap peacock-dropdown-show-label">
      <Dropdown
        childList={options}
        selection="single"
        isRequired={required}
        label={label}
        disabled={!enabled || loading || !!error || isEmpty}
        selectedValue={selected}
        setSelectedValue={handleSelectValue}
        placeholder={placeholder}
      />
      {error && (
        <p role="alert" className="mt-1">
          Unable to load {label || field}. Please try again.
        </p>
      )}
    </div>
  );
};

export const DistinctFieldSelectControl = withJsonFormsControlProps(
  DistinctFieldSelectComponent
);
